import { render, staticRenderFns } from "./customerMobileButton.vue?vue&type=template&id=a5b72bae&scoped=true&"
import script from "./customerMobileButton.vue?vue&type=script&lang=js&"
export * from "./customerMobileButton.vue?vue&type=script&lang=js&"
import style0 from "./customerMobileButton.vue?vue&type=style&index=0&id=a5b72bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b72bae",
  null
  
)

export default component.exports